"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServicesContext = void 0;
const react_1 = __importDefault(require("react"));
const cookieServiceImpl_1 = require("../services/cookieServiceImpl");
const gtmCookieConsentServiceImpl_1 = require("../services/gtmCookieConsentServiceImpl");
const youtubeCookieConsentServiceImpl_1 = require("../services/youtubeCookieConsentServiceImpl");
const klaviyoCookieConsentServiceImpl_1 = require("../services/klaviyoCookieConsentServiceImpl");
const initialize = () => {
    const services = {};
    services["CookieService"] = new cookieServiceImpl_1.CookieServiceImpl("_local-cc");
    services["GtmCookieConsentService"] = new gtmCookieConsentServiceImpl_1.GtmCookieConsentServiceImpl();
    services["YoutubeCookieConsentService"] = new youtubeCookieConsentServiceImpl_1.YoutubeCookieConsentServiceImpl();
    services["KlaviyoCookieConsentService"] = new klaviyoCookieConsentServiceImpl_1.KlaviyoCookieConsentServiceImpl();
    return services;
};
exports.ServicesContext = react_1.default.createContext(initialize());
//# sourceMappingURL=ServicesContext.js.map